import { Observable } from 'rxjs';
import { Action } from 'redux';
import { ofType } from 'redux-observable';
import { delay, filter, map } from 'rxjs/operators';
import { SET_MENU_OPENED } from '../../ui/actions';
import { OpenMenu, CloseMenu } from '../../ui/action-creators';

export const hideSuccessMenuAfterCreatedEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, OpenMenu>(SET_MENU_OPENED),
    filter((action) => action.menuId === 'SUCCESS_SUBSCRIPTION_DIST_PRO'),
    delay(3000),
    map(() => new CloseMenu(undefined, true))
  );
